<div>
  <h3>
    Auftragsrahmen
    @if (('task.frame.change'|HasPerm)) {
      <button class="btn btn-link"
        title="Auftragsrahmen bearbeiten"
        (click)="openUpdateModal()"
        >
        <i class="fa fa-pencil"></i>
      </button>
    }
  </h3>

  @if (frame) {
    <div class="whitebox ordersituation whitebox-margin" [ngClass]="{'alert alert-danger': !frame.approval}"
      >
      @if (lastOffer) {
        <div>
          Aus Angebot:
          <ev-file-button [objId]="lastOffer.id" type="offer">
            {{ lastOffer.id }}
          </ev-file-button>
        </div>
      }
      <div>Menge: {{ frame.quanity }}</div>
      <div>Kalk-Menge: {{ frame.calc_quanity }}</div>
      <div>Lose: {{ frame.lose }}</div>
      <div>Freigabe: {{ frame.release }} </div>
      @if (frame.cost) {
        <div>Einkauf: {{ frame.cost}} $</div>
      }
      <div>Einzel: {{ frame.single }} €</div>
      <div>Kalk: {{ frame.calc }}</div>
      @if (cn) {
        <div>
          @if (!same_exchange) {
            <i class="fa fa-warning" style="color: red;"></i>
          }
          <span [ngClass]="{red_alert: !same_exchange}">Wechselkurs: {{ frame.exchange }}</span>
        </div>
      }
      @if (cn && frame.producer) {
        <div>Produzent: {{frame.producer}}</div>
      }
    </div>
  }

  @if (frame?.date_frame_old) {
    <h3>Alter Auftragsrahmen</h3>
    <div class="whitebox ordersituation whitebox-margin">
      <div>Stand: {{ frame.date_frame_old }}</div>
      <div>Menge: {{ frame.quanity_old }}</div>
      <div>Lose: {{ frame.lose_old }}</div>
      @if (frame.cost) {
        <div>Einkauf: {{ frame.cost_old }}&nbsp;$</div>
      }
      <div>Einzel: {{ frame.single_old }} €</div>
    </div>
  }
</div>
